import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { UpdateAlerts, AddAlert, RemoveAlert } from '../store/actions';
import { Alert, AlertType } from '../typings/alerts';
import { State } from '../typings/state';
import { IDGenerator } from '../helpers/id-generator';

interface Timeouts {
  [alertId: number]: number;
}

interface IAlertToDestroy {
  id: number;
  target: string;
}

@Injectable()
export class AlertService {
  private timeOuts: Timeouts = {};
  private hoveredAlert: number = null;
  private alertToDestroy: IAlertToDestroy = null;

  constructor(private store: Store<State>) {}

  addAlert(target: string, type: AlertType, text: string, click?: () => any | void) {
    const id = IDGenerator();
    const newAlert: Alert = {
      id,
      text,
      type,
      click,
    };
    const timeoutId = window.setTimeout(() => {
      if (this.hoveredAlert === id) {
        this.alertToDestroy = {
          id,
          target,
        };
      } else {
        this.closeAlert(id, target);
      }
    }, 10000);
    this.timeOuts[id] = timeoutId;
    this.store.dispatch(new AddAlert(target, newAlert));
    return id;
  }

  closeAlert(id: number, target: string) {
    if (this.timeOuts[id]) {
      clearTimeout(this.timeOuts[id]);
      delete this.timeOuts[id];
    }
    this.store.dispatch(new RemoveAlert(target, id));
  }

  setHover(id: number) {
    this.hoveredAlert = id;
  }

  unsetHover() {
    this.alertToDestroy && this.closeAlert(this.alertToDestroy.id, this.alertToDestroy.target);
    this.hoveredAlert = null;
    this.alertToDestroy = null;
  }
  /**
   * Destroys all alert-modals by invoking UpdateAlerts with an empty object.
   */
  closeAlerts() {
    this.store.dispatch(new UpdateAlerts({}));
    Object.keys(this.timeOuts).map((key) => clearTimeout(this.timeOuts[Number(key)]));
    this.timeOuts = {};
  }
}
